export const landingPageAssets = {
	hero: {
		characterLeft: "/spec_landing_page/char-left-v2.gif",
		characterRight: "/spec_landing_page/char-right-v2.gif",
		titleBlink: "/spec_landing_page/title-blink-fast.gif"
	}
} as const;
